/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import DashboardPage from "../../../layout";
import { getGlobalFilter } from "../../../api/filters";
import PaginationComponent from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import Export from "../../../assets/icons/Export.svg";
import Filter from "../../../assets/icons/Filter.svg";
import Eye from "../../../assets/eye.svg";
import {
  formatCurrentStartDate,
  formatCurrentEndDate,
  getPagePerSize,
  formatDate,
  formatMinutes,
} from "../../../utility";
import TimeFrameSelector from "../../../components/TimeFrameSelector";
import { useTranslation } from "react-i18next";
import Close from "../../../assets/close-circle.svg";
import Search from "../../../assets/Search.svg";
import { useNavigate } from "react-router-dom";
import { TimeZoneDisplay } from "../../../utility";
import ImageDailog from "../../../components/ImageDailog";
import Dropdown from "../../../components/Dropdown";
import DropdownMulti from "../../../components/DropdownMultiple";
import Button from "../../../components/Button";
import { getDeliveryReport, getDeliveryProofPresignedUrl } from "../../../api/delivery-driver";
import debounce from "lodash/debounce";
import { toast, ToastContainer } from "react-toastify";

import { delivery_man } from "../../../utility/constant";
import moment from "moment";
const DeliveryReport: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [employees, setEmployeesData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingForFilter] = useState(false);
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [deliveryTimeFrame, setDeliveryTimeFrame] = useState<any>("Today");
  const [deliveryStartDate, setDeliveryStartDate] = useState<any>(new Date());
  const [deliveryEndDate, setDeliveryEndDate] = useState<any>(new Date());
  const [filterByCreatedAt, setFilterByCreatedAt] = useState<boolean>(true);
  const [filterByDeliveredAt, setFilterByDeliveredAt] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortType, setSortType] = useState<any>("");
  const { t } = useTranslation();
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState<any>([]);
  const [selectedEmpStatus, setSelectedEmpStauts] = useState<any>("");
  const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>([]);
  const [selectedRegion, setRegion] = useState<any>([]);
    const [DeliveryStatus, setDeliveryStatus] = useState<any>("");
  const [territoryId, setTerritoryId] = useState<any>([]);
  const [routeId, setRouteId] = useState<any>([]);
  const [userType, setUserType] = useState<any>("");
  const [channelId, setChannelId] = useState<any>([]);
      const [viewImg, setViewImg] = useState<any>(false);
      const [imgUrl, setImgUrl] = useState<any>();
      const [imgType, setImgType] = useState<any>();
  const [imageLoading, setImageLoading] = useState(false);
  const startIndex = (currentPage - 1) * employees?.size;
  const navigate = useNavigate();
  const employeesPerPage = getPagePerSize();
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [landingMessage, setLandingMessage] = useState<string>("Apply a filter to see the data.");
  const productHighlightKeys = [
    'Berain24x300ml_Glass_Bottle_Normal_water',
    'Berain24x300ml_Bottled_Glass_carbonated',
    'Berain_28x600_ml_Carton_Brown',
    'Berain_48x200ml_Carton_Special',
    'Berain_40x330ml_Carton_Special',
    'Berain_12x330ml_Shrink_Pack_Special',
    'Berain_20x200ml_Shrink_Pack_Special',
    'Berain24x200ml_Glass_Bottle_Normal_water',
    'Berain24x200ml_Glass_Bottle_Carbonated',
    'Berain_Carton_48x200ml_L_sodium_3',
    'Berain_20x200ml_Shrink_Low_Sodium',
    'Berain_Carton_40x330ml_L_sodium_3',
    'Berain_12x330ml_Shrink_Low_Sodium',
    'MultiPack200ml2x3Bot_w_4PacNormal5_1Free',
    'MultiPack200ml2x3Bot_w_4PacSparkl5_1Free',
    'Multi_pack200ml_2x2Bottles_w_6Pac_Normal',
    'Multi_pack200ml_2x2Bottles_w_6Pac_Sparkl',
    'Multi_pack300ml_2x2Bottles_w_6Pac_Normal',
    'Multi_pack300ml_2x2Bottles_w_6Pac_Sparkl',
    'MultiPack300ml2x3Bot_w_4PacSparkl5_1Free',
    'Berain_24x200ml_Carton',
    'Berain_24x200ml_Shrink_Pack',
    'Berain_28x600ml_Carton',
    'Berain_24x330ml_Carton',
    'Berain_28x500ml_Carton',
    'Berain_24x200ml_Glass_Still_Water',
    'Berain_24x200ml_Glass_Carbonated',
    'Berain_24x300ml_Glass_Still_Water',
    'Berain12x750ml_Glass_Bottle_Still_New',
    'Berain12x750ml_BottledGlassCarbonatedNew',
    'Berain_30x330ml_Carton',
    'Berain330ml_bundle',
    'Berain_12x1_5Ltr_Carton',
    'Bundle_200ml',
    'Berain_2x12_Ltr_Carton',
    'Berain_4x3_8_Ltr_Carton',
    'Berain_4x5_Ltr_Carton',
    'Berain_20x200ml_Shrink_Pack',
    'Berain_12x330ml_Shrink_Pack',
    'Berain_12x600ml_Shrink_Pack',
    'Berain_6x1_5_Ltr_Shrink_Pack',
    'Berain_12x200ml_Shrink_Pack',
    'Berain_12x500ml_Shrink_Pack',
    'Berain_20x200ml_Shrink_Pack_Export',
    'Berain_15x500ml_Shrink_Pack',
    'Berain_24x300ml_Glass_Carbonated',
    'Berain_24x600ml_Carton',
    'Berain24x270ml_Carb_Extra_W_O_Multipack',
    'Berain_24x500ml_Carton',
    'Berain_48x200ml_Carton',
    'Berain_24x330ml_Plain_Shrink',
    'Multi_pack750ml_2x2Bottles_w_2Pac_Normal',
    'Berain24x200ml_Glass_Bottle_Still_M',
    'MultiPack300ml2x3Bot_w_4PacNormal5_1Free',
    'Berain_200ml_x20_Promo_Shrink_16_4_Free',
    'Berain_330ml_x12_Promo_Shrink_10_2_Free',
    'Berain_1_5Liter_x6_PromoShrink_5_1_Free',
    'Berain_500ml_x15_Promo_Shrink_12_3_Free',
    'Berain_24x270ml_Glass_Carbonated',
    'Berain24x200ml_Glass_Bottle_Carbonated_M',
    'Berain24x300ml_Glass_Bottle_Still_M',
    'Berain24x300ml_BottledGlass_carbonated_M',
    'Berain_15x500ml_Shrink_Pack_Low_Sodium',
    'Berain24x300ml_Glass_BottleStill_Low_Sod',
    'Berain_12x1_5Ltr_Carton_Low_Sodium',
    'Berain_Carton40x330ml_Low_Sodium_Special',
    'Berain_carton_24x250ml_Still_Low_Sodium',
    'Multi_pack300ml_2x3Bottles_w_4Pac_Normal',
    'Multi_pack300ml_2x3Bottle_w_4Pac_Sparkle',
    'Berain_12x330ml_Plain_Shrink',
    'Berain_24x270ml_Glass_Still_Water',
    'Berain_24x330ml_Shrink_Pack',
    'Berain24x270ml_Glass_CarbExtra_Multipack',
    'Berain12x750ml_Glass_Bottle_Normal_Water',
    'Berain12x750ml_Bottled_Glass_carbonated',
    'Berain_40x330ml_Carton_Brown',
    'Berain_48x200ml_Carton_Brown',
    'Berain_30x330ml_Shrink_Pack',
    'Multi_pack750ml_2x2Bottles_w_2Pac_Sparkl',
    'Berain12x750ml_Glass_Bottle_Still_M',
    'Berain_24x270ml_Glass_Carbonated_Lemon',
    'Berain_40x330ml_Carton',
    "Berain_Sparkling_Lemon_Gift_Box"
  ];
  const getGlobalFilters = async (data: any) => {
    try {
      setLoadingForFilter(true);
      const response = await getGlobalFilter(data);
      setLoadingForFilter(false);
      setGlobalFilters(response);
    } catch (error) {
      console.error("Error fetching global filters:", error);
    }
  };

  const handleFilterClick = () => {
    setOpen(true);
  };

  const handleChange = (event: any) => {
    setSearchQuery(event);
    updateSearchTerm(event);
  };

  const handleSortFillter = (data: string) => {
    if (data === sortType) {
      setSortType("");
      handleApply("");
    } else {
      setSortType(data);
      handleApply(data);
    }

    setIsDropdownOpen(false);
  };

  function getCurrentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClose = () => setOpen(false);

  const handleClearFilters = () => {
    setSelectedEmpId([]);
    setSelectedSalesOffice([]);
    setRegion([]);
    setDeliveryStatus("");
    setTerritoryId([]);
    setRouteId([]);
    setUserType(null);
    setChannelId([]);
    setSelectedEmpStauts(null);
    setStartDate(getCurrentDate());
    setEndDate(getCurrentDate());
    setSelectTimeFrame("Today");
    setDeliveryStartDate(getCurrentDate());
    setDeliveryEndDate(getCurrentDate());
    setDeliveryTimeFrame("Today");
    setFilterByCreatedAt(true);
    setFilterByDeliveredAt(false);
    setOpen(false);
    setFiltersApplied(false);
    setLandingMessage("Apply a filter to see the data.");
    handleClearApply("");
  };

  const handleClearApply = (sort: string) => {
    // Clear the data when filters are cleared
    setEmployeesData({ items: [], total: 0, size: employeesPerPage });
    setCurrentPage(1);
    handleClose();
  };

  const getPayload = (data: any) => {
    if (selectedEmpStatus) {
      data["status"] = selectedEmpStatus;
    }

    if (channelId.length > 0) {
      data["channel_ids"] = channelId;
    }
    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }    
    if (DeliveryStatus.length > 0) {
      data["status"] = DeliveryStatus;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (userType) {
      data["user_type"] = userType;
    }
    
    // Add filter flags - both can be true now
    data["filter_by_created_at"] = filterByCreatedAt;
    data["filter_by_delivered_at"] = filterByDeliveredAt;
    
    // Add date fields based on which filter is active
    if (filterByCreatedAt && !filterByDeliveredAt) {
      // Only created date filter is active
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    } else if (filterByDeliveredAt && !filterByCreatedAt) {
      // Only delivery date filter is active
      data["start_date"] = formatCurrentStartDate(new Date(deliveryStartDate));
      data["end_date"] = formatCurrentEndDate(new Date(deliveryEndDate));
    } else if (filterByCreatedAt && filterByDeliveredAt) {
      // Both filters are active - use created date as primary
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
      // Add delivery dates as additional fields if needed by backend
      data["delivery_start_date"] = formatCurrentStartDate(new Date(deliveryStartDate));
      data["delivery_end_date"] = formatCurrentEndDate(new Date(deliveryEndDate));
    }
    
    data["positions"] = [delivery_man];
  };

  const handleExport = async () => {
    setLoading(true);
    const data: any = {
      export: true,
      time_zone: TimeZoneDisplay(),
    };

    if (searchQuery) {
      data["search"] = searchQuery;
    }
    if (sortType) {
      data["sort_by"] = sortType;
    }
    getPayload(data);

    const params = {};
    try {
      await exportActiviyData(data, params);
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportActiviyData = async (data: any, params: any) => {
    await getDeliveryReport(params, data)
      .then((res) => {
        toast.success(res?.data?.message)
        setLandingMessage(res?.data?.message || landingMessage);
      })
      .catch((error) => {
        console.error("Error exporting data:", error);
      });
    //   .then((res) => {
    //     const url = window.URL.createObjectURL(new Blob([res]));
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = `team_visit_report.csv`;
    //     a.click();
    //     a.remove();
    //     window.URL.revokeObjectURL(url);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching Employee data:", error);
    //   });
  };
    const handleSetImage = async (url: any, type: string) => {
        try {
            setImageLoading(true);
            const presignedUrl = await getDeliveryProofPresignedUrl(url);
            setImgUrl(presignedUrl);
            setViewImg(true);
            setImgType(type);
        } catch (error) {
            setImgUrl(null);
            setViewImg(false);
        } finally {
            setImageLoading(false);
        }
    };
  const getDeliveryData = async (data: any, params: any) => {
    setLoading(true);
    await getDeliveryReport(params, data)
      .then((res) => {
        setEmployeesData(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching Employee data:", error);
        setLoading(false);
      });
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.value;
    // Prevent selecting a start date more than 30 days before endDate
    const end = new Date(endDate);
    const minDate = new Date(end);
    minDate.setDate(end.getDate() - 31);
    if (new Date(selected) < minDate) {
      setStartDate(minDate.toISOString().split("T")[0]);
      checkTimeFrame(minDate.toISOString().split("T")[0], endDate);
    } else {
      setStartDate(selected);
      checkTimeFrame(selected, endDate);
    }
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
    checkTimeFrame(startDate, e.target.value);
  };

  const handleDeliveryStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.value;
    // Prevent selecting a start date more than 30 days before endDate
    const end = new Date(deliveryEndDate);
    const minDate = new Date(end);
    minDate.setDate(end.getDate() - 31);
    if (new Date(selected) < minDate) {
      setDeliveryStartDate(minDate.toISOString().split("T")[0]);
      checkDeliveryTimeFrame(minDate.toISOString().split("T")[0], deliveryEndDate);
    } else {
      setDeliveryStartDate(selected);
      checkDeliveryTimeFrame(selected, deliveryEndDate);
    }
  };

  const handleDeliveryEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDeliveryEndDate(e.target.value);
    checkDeliveryTimeFrame(deliveryStartDate, e.target.value);
  };

  useEffect(() => {
    // Only call API if filters have been applied
    if (filtersApplied) {
      const data: any = {};

      if (searchQuery) {
        data["search"] = searchQuery;
      }

      getPayload(data);

      const params = {
        page: currentPage,
        size: employeesPerPage,
      };
      getDeliveryData(data, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filtersApplied]);

  useEffect(() => {
    const data: any = {};

    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }
        if (DeliveryStatus.length > 0) {
      data["status"] = DeliveryStatus;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
    getGlobalFilters(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFiltersUpdate = () => {
    const data: any = {};

    if (selectedRegion.length > 0) {
      data["regions"] = selectedRegion;
    }
        if (DeliveryStatus.length > 0) {
      data["status"] = DeliveryStatus;
    }
    if (selectedSalesOffice.length > 0) {
      data["sales_office_ids"] = selectedSalesOffice;
    }
    if (selectedEmpId.length > 0) {
      data["subordinate_ids"] = selectedEmpId;
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
    getGlobalFilters(data);
  };

  const updateSearchTerm = useCallback(
    debounce((value: string) => {
      // Only call API if filters have been applied
      if (filtersApplied) {
        const data: any = {};

        if (value) {
          data["search"] = value;
        }
        getPayload(data);
        const params = {
          page: 1,
          size: employeesPerPage,
        };
        setCurrentPage(1);
        getDeliveryData(data, params);
      }
    }, 500),
    [
      startDate,
      endDate,
      deliveryStartDate,
      deliveryEndDate,
      filterByCreatedAt,
      filterByDeliveredAt,
      selectedEmpStatus,
      channelId,
      selectedRegion,
      DeliveryStatus,
      routeId,
      selectedSalesOffice,
      selectedEmpId,
      territoryId,
      userType,
      sortType,
      employeesPerPage,
      filtersApplied,
    ]
  );

  const handleApply = (sort: string) => {
    // Check if we have any date filters active
    const hasCreatedDateFilter = filterByCreatedAt;
    const hasDeliveryDateFilter = filterByDeliveredAt;
    
    // If no date filters are active, show error or use default
    if (!hasCreatedDateFilter && !hasDeliveryDateFilter) {
      // Set default to created date filter
      setFilterByCreatedAt(true);
    }
    
    // Check if any active filter has multi-day range
    let isMultiDay = false;
    if (hasCreatedDateFilter) {
      const isSingleDay = formatDate(new Date(startDate)) === formatDate(new Date(endDate));
      if (!isSingleDay) isMultiDay = true;
    }
    if (hasDeliveryDateFilter) {
      const isSingleDay = formatDate(new Date(deliveryStartDate)) === formatDate(new Date(deliveryEndDate));
      if (!isSingleDay) isMultiDay = true;
    }
    
    if (isMultiDay) {
      // For multi-day ranges (including Month till date), export directly
      // Show landing screen with toast
      setFiltersApplied(false);
      setEmployeesData({ items: [], total: 0, size: employeesPerPage });
      setCurrentPage(1);
      handleExport();
      handleClose();
      return;
    }
    setCurrentPage(1);
    setFiltersApplied(true);
    const data: any = {};
    if (searchQuery) {
      data["search"] = searchQuery;
    }
    getPayload(data);
    if (sort) {
      data["sort_by"] = sort;
    }
    const params = {
      page: 1,
      size: employeesPerPage,
    };
    getDeliveryData(data, params);
    handleClose();
  };

  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setSelectTimeFrame("Month till date");
    } else {
      setSelectTimeFrame("");
    }
  };

  const checkDeliveryTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setDeliveryTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setDeliveryTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setDeliveryTimeFrame("Month till date");
    } else {
      setDeliveryTimeFrame("");
    }
  };

  const isDeliveryWithinTimeSlot = (deliveryTimestamp: string, timeSlot: string) => {
    if (!deliveryTimestamp || !timeSlot) return false;
    
    try {
      // Parse the delivery timestamp
      const deliveryTime = moment(deliveryTimestamp);
      if (!deliveryTime.isValid()) return false;
      
      // Parse the time slot (format: "HH:mm-HH:mm")
      const [startTimeStr, endTimeStr] = timeSlot.split('-');
      if (!startTimeStr || !endTimeStr) return false;
      
      // Get the date from delivery timestamp
      const deliveryDate = deliveryTime.format('YYYY-MM-DD');
      
      // Create moment objects for start and end times on the same date
      const startTime = moment(`${deliveryDate} ${startTimeStr}`, 'YYYY-MM-DD HH:mm');
      const endTime = moment(`${deliveryDate} ${endTimeStr}`, 'YYYY-MM-DD HH:mm');
      
      if (!startTime.isValid() || !endTime.isValid()) return false;
      
      // Check if delivery time falls within the time slot
      return deliveryTime.isBetween(startTime, endTime, null, '[]'); // '[]' includes the boundaries
    } catch (error) {
      console.error('Error checking time slot:', error);
      return false;
    }
  };

  useEffect(() => {
    setSelectedSalesOffice("");
    setTerritoryId("");
    setRouteId("");
    setSelectedEmpId("");
  }, [selectedRegion]);

  useEffect(() => {
    setTerritoryId("");
    setRouteId("");
    setSelectedEmpId("");
  }, [selectedSalesOffice]);

  useEffect(() => {
    setRouteId("");
    setChannelId("");
    setSelectedEmpId("");
  }, [territoryId]);

  useEffect(() => {
    if (selectedEmpId) {
      globalFilters?.employees?.map((value: any) => {
        if (selectedEmpId === value.id) {
          setUserType(value.position);
        }
      });
    } else {
      setUserType("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmpId]);

  const regionSelected =
    selectedRegion &&
    (Array.isArray(selectedRegion) ? selectedRegion.length > 0 : Boolean(selectedRegion));

  return (
    <DashboardPage>
      <ToastContainer />
      <div className="bg-gray-50  sm:pl-0 pr-4 ">
        {/* Report Title */}
        <div className="bg-white p-4 border-b-2">
          <h1 className="text-l font-bold text-gray-800">
            {t("deliveryreport.title")}
          </h1>
        </div>
        <div className="hidden mb-2 sm:flex flex-col sm:flex-row justify-between items-center bg-white p-2 border-b-2">
          <div className="w-full sm:w-auto mb-4 sm:mb-0 pl-6">
            <PaginationComponent
              totalCount={employees?.total}
              itemsPerPage={employees?.size}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4">
            <div className="relative w-full sm:w-auto">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                {/* Add your search icon here */}
                <img src={Search} alt="search" />
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={t("planogram.search")}
                className="w-full sm:w-auto pl-10 pr-4 py-2 text-16 border rounded text-gray-600"
                style={{ borderColor: "#e0e0e0" }}
              />
            </div>

            {/* Buttons group for desktop */}
            <div className="hidden sm:flex space-x-4 items-center">
              {/* <button
                onClick={handleSort}
                className="flex items-center px-4 py-2 text-16 text-gray-600 rounded transition-all"
              >
                <img src={Sort} alt="Sort Icon" className="w-4 h-4 mr-2" />
                Sort by
              </button> */}
              {isDropdownOpen && (
                <ul className="absolute z-50 right-30 top-10 w-48 bg-white border border-gray-300 rounded shadow-lg">
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${sortType === "ASC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("ASC")}
                  >
                    {t("planogram.ascending")}
                  </li>
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer  ${sortType === "DESC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("DESC")}
                  >
                    {t("planogram.descending")}
                  </li>
                </ul>
              )}
                            <button
                onClick={handleExport}
                className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                    {t("masterList.exporting")}
                  </span>
                ) : (
                  <>
                    {t("masterList.export")}
                    <img
                      src={Export}
                      alt={t("masterList.export")}
                      className="w-4 h-4 "
                    />
                  </>
                )}
              </button>
              <button
                onClick={handleFilterClick}
                className="flex items-center gap-2 px-4 py-2 text-13 font-normal rounded transition-all"
              >
                <img
                  src={Filter}
                  alt={t("planogram.filter")}
                  className="w-4 h-4 mr-2"
                />
                {t("planogram.filter")}
              </button>


            </div>
          </div>
        </div>
        <div className="sm:hidden flex justify-between items-center p-2 border-b-2 bg-white">
          <div className="flex-grow">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => handleChange(e.target.value)}
              placeholder={t("planogram.searchPlaceholder")}
              className="w-full px-4 py-2 text-13 border rounded text-gray-600"
              style={{ borderColor: "#e0e0e0" }}
            />
          </div>

          {/* Hamburger menu for Sort, Filter, Export */}
          <div className="flex items-center space-x-2">
            <button
              onClick={handleExport}
              className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                  {t("masterList.exporting")}
                </span>
              ) : (
                <>
                  {t("masterList.export")}
                  <img
                    src={Export}
                    alt={t("masterList.export")}
                    className="w-4 h-4 "
                  />
                </>
              )}
            </button>

            <button
              className="px-2 py-2 text-gray-600 rounded transition-all"
              onClick={() => setOpen(!open)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        {open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
            <div className="relative bg-white shadow-lg w-full max-w-md h-full">
              <div className="absolute z-30 top-[50%] left-[45%]">
                {loadingFilter && <Loader />}
              </div>
              <div className="flex justify-between p-6 border-b-2">
                <div className="text-16 font-bold">
                  {t("visitreports.filters.title")}
                </div>
                <div>
                  <img
                    className="cursor-pointer"
                    onClick={() => setOpen(false)}
                    src={Close}
                    alt=""
                  />
                </div>
              </div>
              <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6 overflow-y-auto scrollbar scrollbar-thin">
                <div className="flex flex-col gap-[30px]">
                  <div className="flex space-x-4">
                    <div className="w-1/2">
                      <DropdownMulti
                        label={<span>{t("visitreports.filters.region")}<span className="text-red-500">*</span></span>}
                        options={globalFilters?.regions?.map((sales: any) => ({
                          value: sales,
                          label: sales,
                        }))}
                        selectedValues={selectedRegion}
                        onClose={handleFiltersUpdate}
                        onChange={setRegion}
                        placeholder={t("visitreports.filters.selectRegion")}
                        showSelectAll={true}
                      />
                    </div>
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.salesOffice")}
                        options={
                          globalFilters?.sales_offices?.map((sales: any) => ({
                            value: sales.id,
                            label: sales.name,
                          })) || []
                        }
                        selectedValues={selectedSalesOffice}
                        onClose={handleFiltersUpdate}
                        onChange={setSelectedSalesOffice}
                        disabled={!regionSelected || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectSalesOffice"
                        )}
                        showSelectAll={true}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4">
                    {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.territoryID")}
                        options={
                          globalFilters?.territories?.map((emp: any) => ({
                            value: String(emp.territory_id),
                            label: emp.territory_identifier,
                          })) || []
                        }
                        selectedValues={territoryId}
                        onChange={setTerritoryId}
                        onClose={handleFiltersUpdate}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectTerritoryID"
                        )}
                      />
                    </div> */}

                    <div className="w-full">
                      <DropdownMulti
                        label={<span>{t("visitreports.filters.channelID")}<span className="text-red-500">*</span></span>}
                        options={
                          globalFilters?.channels?.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name,
                          })) || []
                        }
                        selectedValues={channelId}
                        onClose={handleFiltersUpdate}
                        onChange={setChannelId}
                        disabled={!regionSelected || loadingFilter}
                        placeholder={t("visitreports.filters.selectChannelID")}
                      />
                    </div>
                  </div>
                  {/* <div>
                    <div className="w-full">
                      <DropdownMulti
                        label={t("visitreports.filters.routeID")}
                        options={
                          globalFilters?.routes?.map((emp: any) => ({
                            value: `${emp.route_id}`,
                            label: emp.route_identifier,
                          })) || []
                        }
                        selectedValues={routeId}
                        onClose={handleFiltersUpdate}
                        onChange={setRouteId}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectRouteID")}
                      />
                    </div>
                  </div> */}
                  <div className="flex gap-4">
                    <div className="w-full">
                      <DropdownMulti
                        label={t("ActivityReport.employeeName")}
                        options={
                          globalFilters?.employees.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng + " (" + emp.id + ")",
                          })) || []
                        }
                        selectedValues={selectedEmpId}
                        onClose={handleFiltersUpdate}
                        onChange={setSelectedEmpId}
                        disabled={!regionSelected || loadingFilter}
                        placeholder={t("ActivityReport.employeeName")}
                        searchable={true}
                      />
                    </div>
                    {/* <div className="w-1/2">
                      <Dropdown
                        label={t("visitreports.filters.userType")}
                        options={
                          globalFilters?.user_types.map((emp: any) => ({
                            value: emp,
                            label: emp,
                          })) || []
                        }
                        selectedValue={userType}
                        onChange={setUserType}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectUserType")}
                      />
                    </div> */}
                  </div>
 <div className="w-full">
                     <Dropdown
                        label={t("visitreports.filters.deliverystatus")}
                        options={globalFilters?.delivery_status.map((status: any) => ({
                          value: status,
                          label: status,
                        }))}
                        selectedValue={DeliveryStatus}
                        onChange={setDeliveryStatus}
                        disabled={!regionSelected || loadingFilter}
                        placeholder={t("visitreports.filters.deliverystatus")}
                      />
                    </div>
                  {/* Created Date Section */}
                  <div 
                    className={`date-range-picker space-y-2 p-4 border-2 rounded-lg ${
                      regionSelected ? 'cursor-pointer' : 'cursor-not-allowed opacity-60 pointer-events-none'
                    } ${
                      filterByCreatedAt 
                        ? 'border-purple-500 bg-purple-50' 
                        : 'border-gray-200 bg-gray-50 opacity-60 hover:opacity-80 hover:border-gray-300'
                    }`}
                    onClick={() => {
                      if (!regionSelected) return;
                      setFilterByCreatedAt(true);
                      setFilterByDeliveredAt(false);
                    }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <label className={`block text-14 font-semibold ${
                        filterByCreatedAt ? 'text-gray-700' : 'text-gray-500'
                      }`}>
                       Filter By Order Creation Date:
                      </label>
                    </div>
                    <div className="flex space-x-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.startDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByCreatedAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                          }`}
                          value={startDate}
                          onChange={handleStartDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(true);
                            setFilterByDeliveredAt(false);
                          }}
                          max={new Date(endDate).toISOString().split("T")[0]}
                          min={(() => {
                            const end = new Date(endDate);
                            const minDate = new Date(end);
                            minDate.setDate(end.getDate() - 30);
                            return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                          })()}
                          disabled={!regionSelected || loadingFilter}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.endDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByCreatedAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                          }`}
                          max={new Date().toISOString().split("T")[0]}
                          min={new Date(startDate).toISOString().split("T")[0]}
                          value={endDate}
                          onChange={handleEndDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(true);
                            setFilterByDeliveredAt(false);
                          }}
                          disabled={!regionSelected || loadingFilter}
                        />
                      </div>
                    </div>
                    <div>
                                          <div                           onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(true);
                            setFilterByDeliveredAt(false);
                          }}>
                        <TimeFrameSelector
                          customClass={`w-full border-2 rounded p-2 ${
                            filterByCreatedAt ? 'border-gray-300' : 'border-gray-300 bg-gray-100'
                          }`}
                          setSelectTimeFrame={setSelectTimeFrame}
                          timeFrame={timeFrame}
                          setStartDate={setStartDate}
                          setEndDate={setEndDate}
                          disabled={!regionSelected || loadingFilter}
                        />
                      </div>
                  </div>
                  </div>

  

                  {/* Delivery Date Section */}
                  <div 
                    className={`date-range-picker space-y-2 p-4 border-2 rounded-lg ${
                      regionSelected ? 'cursor-pointer' : 'cursor-not-allowed opacity-60 pointer-events-none'
                    } ${
                      filterByDeliveredAt 
                        ? 'border-purple-500 bg-purple-50' 
                        : 'border-gray-200 bg-gray-50 opacity-60 hover:opacity-80 hover:border-gray-300'
                    }`}
                    onClick={() => {
                      if (!regionSelected) return;
                      setFilterByCreatedAt(false);
                      setFilterByDeliveredAt(true);
                    }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <label className={`block text-14 font-semibold ${
                        filterByDeliveredAt ? 'text-gray-700' : 'text-gray-500'
                      }`}>
                      Filter By Order Delivery Date:
                      </label>
                    </div>
                    <div className="flex space-x-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.startDate")}:
                        </label>
                        <input
                              
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByDeliveredAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                            
                          }`}
                          value={deliveryStartDate}
                          onChange={handleDeliveryStartDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(false);
                            setFilterByDeliveredAt(true);
                          }}
                          max={new Date(deliveryEndDate).toISOString().split("T")[0]}
                          min={(() => {
                            const end = new Date(deliveryEndDate);
                            const minDate = new Date(end);
                            minDate.setDate(end.getDate() - 30);
                            return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                          })()}
                          disabled={!regionSelected || loadingFilter}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.endDate")}:
                        </label>
                        <input
                          type="date"
                          className={`rounded p-2 border-2 w-full ${
                            filterByDeliveredAt ? 'border-gray-400' : 'border-gray-300 bg-gray-100'
                          }`}
                          max={new Date().toISOString().split("T")[0]}
                          min={new Date(deliveryStartDate).toISOString().split("T")[0]}
                          value={deliveryEndDate}
                          onChange={handleDeliveryEndDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(false);
                            setFilterByDeliveredAt(true);
                          }}
                          disabled={!regionSelected || loadingFilter}
                        />
                      </div>
                      
                    </div>
                    <div>
                                          <div                           onClick={(e) => {
                            e.stopPropagation();
                            setFilterByCreatedAt(false);
                            setFilterByDeliveredAt(true);
                          }}>
                        <TimeFrameSelector
                          customClass={`w-full border-2 rounded p-2 ${
                            filterByDeliveredAt ? 'border-gray-300' : 'border-gray-300 bg-gray-100'
                          }`}
                          setSelectTimeFrame={setDeliveryTimeFrame}
                          timeFrame={deliveryTimeFrame}
                          setStartDate={setDeliveryStartDate}
                          setEndDate={setDeliveryEndDate}
                          
                          disabled={!regionSelected || loadingFilter}
                        />
                      </div>
                  </div>
                  </div>

                 
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between mt-4">
                  <Button
                    onClick={handleClearFilters}
                    label={t("visitreports.filters.clearFilter")}
                    type="grey"
                  />
                  <Button
                    onClick={() => handleApply(sortType)}
                    label={t("visitreports.filters.applyFilter")}
                    type="purple"
                    disabled={!regionSelected}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-125px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
          {!filtersApplied ? (
            <div className="flex items-center justify-center h-full text-gray-500 text-lg font-semibold">
              {landingMessage}
            </div>
          ) : (
            <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
                          <thead className="bg-gray-200 sticky top-[0px] z-20">
              <tr>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.created_at')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.created_at_time')}</th>

                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sap_order_creation_date')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sap_order_creation_time')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.supervisor_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.customer_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.customer_name')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_check_in_time')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_check_out_time')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.total_time_minutes')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_number')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.invoice_no')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.mosque_image_path')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.cooler_image_path')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.stock_floor_image_path')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.stamped_invoice_image_path')}</th>


                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.customer_telephone')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.actual_delivery_date')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.actual_delivery_time')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.order_status')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_status')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.mosque_delivery_area')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.payment_term')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.begin_time_slot')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.end_time_slot')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_timestamp')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.division_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.collection_payment_method')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.express_delivery_order')}</th>

                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.collection_document_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.collection_pending')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sap_order_cancelled_date')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sap_order_cancelled_time')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.stamped_invoice_required')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.b2b_planogram_required')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivered_latitude')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivered_longitude')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_executive_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_executive_name')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_executive_name_arb')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_executive_phone')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.region')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sales_office')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sales_channel')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.order_type')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.customer_address_street_name')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.reference_number')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.requested_delivery_date')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.discount_percent')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.discount_amount')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.marketing_discount_amount')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.total_value')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.promotion_code')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.preseller_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.preseller_name')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.preffered_delivery_time')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.wallet_paid')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.wallet_amount')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.purchase_order')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.purchase_order_date')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.promo_code_amount')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.proof_of_delivery')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.threshold_limit')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.outlet_name_en')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.outlet_name_ar')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.payer_name_en')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.payer_name_ar')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.division_text')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.sales_office_id')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.vat')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.country_code')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.payment_term_description')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.vat_no')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.cr_no')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.partial_payment')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.amount_to_be_paid')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delivery_charges')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.gross_value')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.payment_reference')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.total_invoiced_qty')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.total_invoiced_carton_qty')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.delayreason')}</th>
                
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.van_location')}</th>

                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x300ml_Glass_Bottle_Normal_water')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x300ml_Bottled_Glass_carbonated')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_28x600_ml_Carton_Brown')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_48x200ml_Carton_Special')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_40x330ml_Carton_Special')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x330ml_Shrink_Pack_Special')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_20x200ml_Shrink_Pack_Special')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x200ml_Glass_Bottle_Normal_water')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x200ml_Glass_Bottle_Carbonated')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_Carton_48x200ml_L_sodium_3')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_20x200ml_Shrink_Low_Sodium')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_Carton_40x330ml_L_sodium_3')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x330ml_Shrink_Low_Sodium')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.MultiPack200ml2x3Bot_w_4PacNormal5_1Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.MultiPack200ml2x3Bot_w_4PacSparkl5_1Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack200ml_2x2Bottles_w_6Pac_Normal')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack200ml_2x2Bottles_w_6Pac_Sparkl')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack300ml_2x2Bottles_w_6Pac_Normal')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack300ml_2x2Bottles_w_6Pac_Sparkl')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.MultiPack300ml2x3Bot_w_4PacSparkl5_1Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x200ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x200ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_28x600ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x330ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_28x500ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x200ml_Glass_Still_Water')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x200ml_Glass_Carbonated')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x300ml_Glass_Still_Water')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain12x750ml_Glass_Bottle_Still_New')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain12x750ml_BottledGlassCarbonatedNew')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_30x330ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain330ml_bundle')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x1_5Ltr_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Bundle_200ml')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_2x12_Ltr_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_4x3_8_Ltr_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_4x5_Ltr_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_20x200ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x330ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x600ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_6x1_5_Ltr_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x200ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x500ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_20x200ml_Shrink_Pack_Export')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_15x500ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x300ml_Glass_Carbonated')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x600ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x270ml_Carb_Extra_W_O_Multipack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x500ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_48x200ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x330ml_Plain_Shrink')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack750ml_2x2Bottles_w_2Pac_Normal')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x200ml_Glass_Bottle_Still_M')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.MultiPack300ml2x3Bot_w_4PacNormal5_1Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_200ml_x20_Promo_Shrink_16_4_Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_330ml_x12_Promo_Shrink_10_2_Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_1_5Liter_x6_PromoShrink_5_1_Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_500ml_x15_Promo_Shrink_12_3_Free')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x270ml_Glass_Carbonated')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x200ml_Glass_Bottle_Carbonated_M')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x300ml_Glass_Bottle_Still_M')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x300ml_BottledGlass_carbonated_M')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_15x500ml_Shrink_Pack_Low_Sodium')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x300ml_Glass_BottleStill_Low_Sod')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x1_5Ltr_Carton_Low_Sodium')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_Carton40x330ml_Low_Sodium_Special')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_carton_24x250ml_Still_Low_Sodium')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack300ml_2x3Bottles_w_4Pac_Normal')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack300ml_2x3Bottle_w_4Pac_Sparkle')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_12x330ml_Plain_Shrink')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x270ml_Glass_Still_Water')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x330ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain24x270ml_Glass_CarbExtra_Multipack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain12x750ml_Glass_Bottle_Normal_Water')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain12x750ml_Bottled_Glass_carbonated')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_40x330ml_Carton_Brown')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_48x200ml_Carton_Brown')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_30x330ml_Shrink_Pack')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Multi_pack750ml_2x2Bottles_w_2Pac_Sparkl')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain12x750ml_Glass_Bottle_Still_M')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_24x270ml_Glass_Carbonated_Lemon')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_40x330ml_Carton')}</th>
                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('deliveryReportTableFields.Berain_Sparkling_Lemon_Gift_Box')}</th>

              </tr>
            </thead>
              <tbody>
                {employees?.items?.length > 0 &&
                  !loading &&
                  employees.items.map((data: any, index: number) => (
                    <tr
                      key={data.emp_id}
                      className="text-16 	hover:bg-gray-50"
                    >
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatDate(data.created_at)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.created_at && data.created_at !== "00:00:00" ? moment
                                                                      .utc(data.created_at, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>

                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatDate(data.sap_order_creation_date)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sap_order_creation_time && data.sap_order_creation_time !== "00:00:00" ? moment
                                                                      .utc(data.sap_order_creation_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.supervisor_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_name}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_check_in_time && data.delivery_check_in_time !== "00:00:00" ? moment
                                                                      .utc(data.delivery_check_in_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_check_out_time && data.delivery_check_out_time !== "00:00:00" ? moment
                                                                      .utc(data.delivery_check_out_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                        {data.total_time_minutes !== undefined && data.total_time_minutes !== null && data.total_time_minutes !== ""
                          ? formatMinutes(Number(data.total_time_minutes), 'mm:ss', 'round')
                          : "-"}
                      </td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_number}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.invoice_no}</td>
<td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.mosque_image_path ? (
                          <button onClick={() => handleSetImage(data.mosque_image_path, "Mosque Image")}>
                            <img src={Eye} alt="mosque_image" />
                          </button>
                        ) : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.cooler_image_path && Number(data.channel_id) !== 40 && Number(data.sales_channel) !== 40 ? (
                          <button onClick={() => handleSetImage(data.cooler_image_path, "Cooler Image")}>
                            <img src={Eye} alt="cooler_image" />
                          </button>
                        ) : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
 {data.stock_floor_image_path ? (
                          <button onClick={() => handleSetImage(data.stock_floor_image_path, "Stock Floor Image")}>
                            <img src={Eye} alt="stock_floor_image" />
                          </button>
                        ) : "-"}
</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.stamped_invoice_image_path ? (
                          <button onClick={() => handleSetImage(data.stamped_invoice_image_path, "Stamped Invoice Image")}>
                            <img src={Eye} alt="stamped_invoice_image" />
                          </button>
                        ) : "-"}</td>



                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_telephone}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatDate(data.actual_delivery_date)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.actual_delivery_time? moment
                                                                      .utc(data.actual_delivery_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.order_status}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_status ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.mosque_delivery_area}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.payment_term}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                        {data.time_slot ? data.time_slot.split('-')[0] : "-"}
                      </td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                        {data.time_slot ? data.time_slot.split('-')[1] : "-"}
                      </td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                        {data.delivery_timestamp && data.time_slot 
                          ? (isDeliveryWithinTimeSlot(data.delivery_timestamp, data.time_slot) ? 'Yes' : 'No')
                          : "-"
                        }
                      </td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.division_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.collection_payment_method}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                        {data.express_delivery_order === 'X' ? 'Yes' : 'No'}
                      </td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.collection_document_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.collection_pending ? 'Yes' : 'No'}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sap_order_cancelled_date ? formatDate(data.sap_order_cancelled_date) : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sap_order_cancelled_time?moment
                                                                      .utc(data.sap_order_cancelled_time, "HH:mm:ss.SSSSSS")
                                                                      .local()
                                                                      .format("hh:mm A")
                                                                    : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.stamped_invoice_required ? 'Yes' : 'No'}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.b2b_planogram_required ? 'Yes' : 'No'}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivered_latitude}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivered_longitude}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_executive_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_executive_name}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_executive_name_arb}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_executive_phone}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.region}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sales_office}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sales_channel}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.order_type}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_address_street_name}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.reference_number}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatDate(data.requested_delivery_date)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.discount_percent}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.discount_amount}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.marketing_discount_amount}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.total_value}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.promotion_code}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.preseller_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.preseller_name}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.preffered_delivery_time}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.wallet_paid ? 'Yes' : 'No'}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.wallet_amount}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.purchase_order}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatDate(data.purchase_order_date)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.promo_code_amount}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.proof_of_delivery}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.threshold_limit}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.outlet_name_en}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.outlet_name_ar}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.payer_name_en}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.payer_name_ar}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.division_text}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sales_office_id}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.vat}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.country_code}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.payment_term_description}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.vat_no}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.cr_no}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.partial_payment}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.amount_to_be_paid}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_charges}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.gross_value}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.payment_reference}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.total_invoiced_qty}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.total_invoiced_carton_qty}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delay_reason}</td>

                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.van_location}</td>
                      {productHighlightKeys.map((key) => (
  <td key={key} className={`px-4 py-3 border text-black-600 whitespace-nowrap ${data[key] > 1 ? 'bg-green-100' : ''}`}>{data[key]}</td>
))}
                     
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
          {filtersApplied && employees?.items?.length === 0 && !loading && (
            <div className="px-4 py-3 border text-center text-black-600 w-full flex items-center justify-center">
              {t("planogram.noresultsfound")}
            </div>
          )}
          {filtersApplied && loading && <Loader />}
        </div>
        <div className="sm:hidden bg-white p-2 border-t-2 mt-auto">
          <PaginationComponent
            totalCount={employees?.total}
            itemsPerPage={employees?.size}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
        {viewImg && (
            <>
                <ImageDailog
                    imageUrl={imgUrl}
                    onClose={() => setViewImg(false)}
                    title={imgType}
                />
                {imageLoading && (
                    <div style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999}}>
                        <Loader />
                    </div>
                )}
            </>
        )}
      </div>
    </DashboardPage>
  );
};

export default DeliveryReport;
